import { Body, Button, Heading } from '@iclinic/design-system';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { image } from 'shared/utils/urlGetter';
import { getScheduleInfoData } from 'features/messaging/state/patients/selectors';
import { formatInFullDateMessage } from 'features/messaging/formatters';
import { formatTime } from 'shared/utils/date';
import { onlyNumbers } from 'shared/utils/formatters';
import {
  ButtonWrapper,
  Card,
  CardContainer,
  CardContent,
  MainCard,
  Image,
} from '../Common.styles';

export function NotConfirmationAppointment() {
  const appointmentData = useSelector(getScheduleInfoData);

  const handleRescheduleClick = useCallback(() => {
    const whatsappURL = `https://api.whatsapp.com/send?phone=55${onlyNumbers(
      appointmentData?.clinic.phone || '',
    )}`;
    window.open(whatsappURL, '_blank');
  }, [appointmentData]);

  return (
    <MainCard>
      <Card>
        <CardContainer>
          <Image>
            <img
              src={image('appointmentConfirmation.imageCanceled')}
              alt="imagem de agenda cancelada"
            />
          </Image>
          <CardContent>
            <Heading variant="lg" align="center">
              Agendamento não confirmado
            </Heading>
            <Body variant="sm">
              Se você cancelou esse agendamento em algum momento, não <br />
              poderá confirmá-lo em seguida, por isso infelizmente não <br />
              podemos concluir a confirmação de seu agendamento com{' '}
              {appointmentData?.physician.name},
              <br />{' '}
              {appointmentData?.event_date
                ? formatInFullDateMessage(appointmentData.event_date)
                : ''}{' '}
              às{' '}
              {appointmentData?.event_time
                ? formatTime(appointmentData.event_time)
                : ''}
              .
            </Body>
          </CardContent>
        </CardContainer>
        <ButtonWrapper>
          {appointmentData?.clinic.phone ? (
            <Button
              size="large"
              variant="contained"
              onClick={handleRescheduleClick}
            >
              Reagendar
            </Button>
          ) : null}
        </ButtonWrapper>
      </Card>
    </MainCard>
  );
}
